import { Fancybox } from "@fancyapps/ui";

import swiper from "./components/Swiper";
import menu from "./components/Menu";
import phone from "./components/Phone";
import callback from "./components/Callback";
try {
    window.$ = window.jQuery = require('jquery');
    window._ = require('lodash');

    callback();
    swiper();
    menu();
    phone();

} catch (e) {
    console.log(e);
}

Fancybox.bind("[data-fancybox]", {
    // Your options go here
});
